const FieldWrapper = ({id, label, info, description, children, classes, wrapperClasses = ''}) => (
    <div className={classes}>
        <label className={classes + '-label'} htmlFor={id}>
            {label}
            {info && <span className="label-info text-small-regular">{info}</span>}
            {description && <p className="label-description text-small-light">{description}</p>}
        </label>
        <div className={wrapperClasses}>
            {children}
        </div>
    </div>
)

export default FieldWrapper